import React, { useCallback, useEffect, useState } from 'react';
import useFetch from '../../hooks/useFetch';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';
import logo from '../../assets/logo.png';
import "../../styles/MyProfile.css";
import { faBriefcaseClock } from '@fortawesome/free-solid-svg-icons';
import QRCode from 'react-qr-code';


const MyDigitalCardBlue = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData] = useFetch();
  const userId = authState.user._id;
  const userCode = authState.user.think5whyscode;

  const [profileData, setProfileData] = useState({
    userId: authState.user._id,
    name: authState.user.name,
    gender: 0,
    dob: '',
    email: authState.user.email,
    mobile: '',
    city: '',
    personalPageLink: '',
    think5whysCode: authState.user.think5whyscode,
    image: '',
  });

  const [profileExists, setProfileExists] = useState(false);
  const [profileId, setProfileId] = useState('');
  const [loading, setLoading] = useState(true);
  const [createSuccessMsg, setCreateSuccessMsg] = useState('');
  const [urlToScan, setUrlToScan]=useState('');

  const buttonStyle = {
    marginLeft: '10px',
    padding: '5px 10px',
    fontSize: '11px',
    cursor: 'pointer',
    borderRadius: '5px',
    border: 'none',
    backgroundColor: '#0000ab',
    color: '#fff'
  };

  const button1Style = {
    margin: '10px',
    padding: '10px',
    fontSize: '11px',
    backgroundColor: '#0000ee',
  };

  const button2Style = {
    margin: '10px',
    padding: '10px',
    fontSize: '14px',
    backgroundColor: '#0000ee',
  };

  useEffect(() => {
    fetchUserProfile(userId);
  }, [userId]);

  const fetchUserProfile = useCallback(() => {
    const config = {
      url: "/blueprofile/byid",
      method: 'post',
      data: { userId: userId },
      headers: { Authorization: authState.token },
    };
    fetchData(config)
      .then(response => {
        if (response && response.status) {
          setProfileExists(true);
          const { blueProfile } = response;
          setProfileId(blueProfile._id);
          setProfileData({
            userId: blueProfile.userId,
            name: blueProfile.name,
            gender: blueProfile.gender,
            dob: blueProfile.dob,
            email: blueProfile.email,
            mobile: blueProfile.mobile,
            city: blueProfile.city,
            personalPageLink: blueProfile.personalPageLink,
            think5whysCode: blueProfile.think5whysCode,
            bloodGroup: blueProfile.bloodGroup,
          });
        } else {
          setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
        }
      })
      .catch(error => {
        console.error("Error getting profile:", error);
        setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
      });
  }, [userId, fetchData, authState.token]);

  const origin = window.location.origin;
  const qrValue = `${origin}/pub/blue/${profileData.think5whysCode}`;
  // const qrValue = encodeURIComponent(`${window.location.origin}/pub/${profileData.think5whysCode}`);
  // console.log(qrValue);


  const handleCallClick = (contactNumber) => {
    window.location.href = `tel:${contactNumber}`;
  };

  const handleWhatsAppClick = (contactNumber) => {
    const whatsappUrl = `https://wa.me/${contactNumber}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleEmailClick = (contactEmail) => {
      window.location.href = `mailto:${contactEmail}`;
  };

   const handleEmergencyCallClick = (contactNumber) => {
    window.location.href = `tel:${contactNumber}`;
  };

  const handleAvailabilityClick = () => {
    
  };

  const handleWorkHistoryClick = () => {
    
  };

  const handleFeedbacksClick = () => {
    
  };


  const handlePointOfViewClick = () => {
    
  };


  const handlePersonalDetailsClick = () => {
    
  };

  const handleKYCInfoClick = () => {
    
  };

  const handleInsuranceDetailsClick = () => {
    
  };

  const handleSkillScoresClick = () => {
    
  };

  return (
      <div className="flex flex-col justify-center items-center p-4 relative">
        <div className="bg-gradient-to-r from-blue-500 to-blue-800 border border-gray-600 rounded-lg shadow-lg w-full max-w-sm p-4">
          <div className="flex justify-center mb-4">
          <img 
              src={
                `/api/downloads/users/profilepic/${profileData.think5whysCode}.png` || 
                `/api/downloads/users/profilepic/noprofilepic.png`
              }
              alt="Profile Pic" 
              className="w-32 h-32 rounded-full border-4 border-yellow-400" 
            />
          </div>
          <h2 className="text-white font-bold text-2xl mb-2 text-center">{profileData.name}</h2>
          <p className="text-sm text-white mb-1 text-center">ID#: {profileData.think5whysCode}</p>
          <p className="text-sm text-white mb-1 text-center">Blood Group: {profileData.bloodGroup}</p>
          <p className="text-sm text-white mb-1 text-center">Email: {profileData.email}</p>
          <p className="text-sm text-white mb-1 text-center">Mobile: {profileData.mobile}</p>
          <p className="text-sm text-white mb-4 text-center">Place: {profileData.city}</p>
          <div className="flex justify-around">
            <button onClick={() => handleAvailabilityClick()} style={buttonStyle}>
              📅 Availability
            </button>
            <button onClick={() => handleWorkHistoryClick()} style={buttonStyle}>
              💼 Work
            </button>
            <button onClick={() => handleFeedbacksClick()} style={buttonStyle}>
              📝 Feedback
            </button>
            <button onClick={() => handleSkillScoresClick()} style={buttonStyle}>
              🧠 Skills
            </button>
          </div>
          <div className="flex justify-around mb-4">
            <button onClick={() => handlePersonalDetailsClick()} style={button1Style}>
              🧍 Details
            </button>
            <button onClick={() => handleKYCInfoClick()} style={button1Style}>
              🛂 KYC
            </button>
            <button onClick={() => handlePointOfViewClick()} style={button1Style}>
              💬 POV
            </button>
            <button onClick={() => handleInsuranceDetailsClick()} style={button1Style}>
              🏥 Insurance
            </button>
          </div>
          <div className="flex justify-around mb-4">
            <button onClick={() => handleCallClick()} style={button2Style}>
              📞
            </button>
            <button onClick={() => handleWhatsAppClick()} style={button2Style}>
              💬
            </button>
            <button onClick={() => handleEmailClick()} style={button2Style}>
              ✉️
            </button>
            <button onClick={() => handleEmergencyCallClick()} style={button2Style}>
              📞 Emergency
            </button>
          </div>
          
        <div className="bg-black border-4 border-gray-600 rounded-lg mt-2 p-4 w-full max-w-sm flex flex-col justify-center items-center">
          <QRCode value={qrValue} size={128} className="bg-white p-2 rounded-md shadow-md" />
          <a href={qrValue} target="_blank" rel="noopener noreferrer" className='mt-4 text-xs flex flex-wrap items-center'>
            {qrValue}
          </a>
        </div>
        <div className="rounded-lg mt-2 p-4 w-full max-w-sm flex flex-col justify-center items-center">
          <p className="text-yellow-200 text-center text-sm py-2 rounded-md mt-2">
              Powered by <img src={logo} alt="Think5Whys" className="inline-block w-6 h-6 mx-2"/> think5whys.com
          </p>
        </div>
      </div>
    </div>
   );
};

export default MyDigitalCardBlue;
